import _str from "shared/util/_str";
import { isDesktop } from "shared/util/EnvironmentHelpers";

export const SECTIONS = {
	INSTAGRAM: "insta",
	INSTAGRAM_BLANK: "no_insta",
};

export const SECTION_TITLES = {
	[SECTIONS.INSTAGRAM]: _str("Instagram"),
	[SECTIONS.INSTAGRAM_BLANK]: _str("Instagram"),
};

export const INSTAGRAM_ALBUM_ID = "i";
export const PROFILE_ALBUM_ID = 0;

export const PHOTOS_PER_PAGE = 6;

// these should be kept in sync with variables.scss
export const PHOTO_SIZE = 164;
export const PHOTO_GUTTER = 8;
export const MW_PROFILE_PAGE_PADDING = 16;
export const PHOTO_SECTION_WIDTH = isDesktop
	? PHOTO_SIZE * 3 + PHOTO_GUTTER * 2
	: document.body.clientWidth - (MW_PROFILE_PAGE_PADDING * 2);



// WEBPACK FOOTER //
// ./src/apps/profile_instagram/util/constants.js